import API from '../Utils/API';

export const getWaiters = () => (dispatch) => {
  dispatch({ type: 'GET_WAITERS_REQUEST' });
  API.get(`api/organization_waiters`)
    .then((response) => {
      dispatch({ type: 'GET_WAITERS_SUCCESS', payload: response.data });
    })
    .catch((error) => {
      try {
        dispatch({
          type: 'GET_WAITERS_FAILURE',
          payload: error.response.data,
        });
      } catch {}
    });
};

export const createWaiter =
  (data, successCreateWaiter, failureCreateWaiter) => (dispatch) => {
    dispatch({ type: 'CREATE_WAITER_REQUEST' });
    API.post('api/organization_waiters', data)
      .then((response) => {
        dispatch({
          type: 'CREATE_WAITER_SUCCESS',
          payload: response.data,
        });
        successCreateWaiter && successCreateWaiter();
      })
      .catch((error) => {
        dispatch({
          type: 'CREATE_WAITER_FAILURE',
          payload: error.response.data,
        });
        failureCreateWaiter && failureCreateWaiter(error.response.data);
      });
  };

export const updateWaiter =
  (data, successUpdateCallBack, failureUpdateCallBack) => (dispatch) => {
    dispatch({ type: 'UPDATE_WAITER_REQUEST' });
    API.put(`api/organization_waiters/${data.id}`, data)
      .then((response) => {
        dispatch({ type: 'UPDATE_WAITER_SUCCESS', payload: response.data });
        successUpdateCallBack && successUpdateCallBack();
      })
      .catch((error) => {
        dispatch({
          type: 'UPDATE_WAITER_FAILURE',
          payload: error.response.data,
        });
        failureUpdateCallBack && failureUpdateCallBack(error.response.data);
      });
  };

export const getWaiterById = (Id) => (dispatch) => {
  dispatch({ type: 'GET_WAITER_BY_ID_REQUEST' });
  API.get(`api/organization_waiters/${Id}`)
    .then((response) => {
      dispatch({
        type: 'GET_WAITER_BY_ID_SUCCESS',
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_WAITER_BY_ID_FAILURE',
        payload: error?.response.data,
      });
    });
};

export const deleteWaiter = (waiterId, successDeleteCallback) => (dispatch) => {
  dispatch({ type: 'DELETE_WAITER_REQUEST' });
  API.delete(`/api/organization_waiters/${waiterId}`)
    .then((response) => {
      dispatch({ type: 'DELETE_WAITER_SUCCESS', payload: response.data });
      successDeleteCallback && successDeleteCallback();
    })
    .catch((error) => {
      dispatch({
        type: 'DELETE_WAITER_FAILURE',
        payload: error.response.data,
      });
    });
};
